/*
    Блокировка скролла
*/

import { throttle } from './Util.js';


export class LockScroll {
    constructor() {
        this.ios = App.H.is('.ios');
        this.scroll = 0;

        this.bindResize();
    }

    lock() {
        this.scroll = App.W.scrollTop();
        const w = App.B.width();

        // if (ios) {
            // const h = App.W.height();
            // App.B.height(h + 100);
            // App.H.height(h + 100);
        // } else {
            // App.H.addClass('_noscroll');
            App.B.addClass('_noscroll').css({ 'width': w });
            $('html, body').scrollTop(this.scroll);
        // }
    }

    unlock() {
        // if (ios) {
            // App.B.height('');
            // App.H.height('');
            // App.B.scrollTop(scroll);
        // } else {
            // App.H.removeClass('_noscroll');
            App.B.removeClass('_noscroll').css({ 'width': 'auto' });
            $('html, body').scrollTop(this.scroll);
        // }
    }

    bindResize() {
        App.W.off('resize.ls').on('resize.ls', throttle(function() {
            if (App.B.hasClass('_noscroll')) {
                App.B.css({ 'width': App.W.width() });
            }
        }, 100));
    }
}



// WEBPACK FOOTER //
// ./_src/js/modules/LockScroll.js